module.exports = __webpack_public_path__ + "img/figure-16.13fb2241.png";